import { render, staticRenderFns } from "./werkwijze.vue?vue&type=template&id=46fedb73&scoped=true&"
import script from "./werkwijze.vue?vue&type=script&lang=ts&"
export * from "./werkwijze.vue?vue&type=script&lang=ts&"
import style0 from "./werkwijze.vue?vue&type=style&index=0&id=46fedb73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fedb73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VImg,VRow})
